import {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';

import {hasCompletedBadgeActions} from '@/services/loyalty/loyaltyUtils';
import {selectCompletedJourneys} from '@/state/selectors/consumerLoyalty';
import {selectIsJourneyBadgePending} from '@/state/selectors/loyalty';
import {setJourneyBadgePending, setJourneyBadgePopupState} from '@/state/slices/loyaltySlice';
import {dispatch} from '@/state/store';

const useCheckBadgeEarn = () => {
    const isPending = useSelector(selectIsJourneyBadgePending);
    const completedJourneys = useSelector(selectCompletedJourneys) || [];
    const previousJourneysRef = useRef(null);

    useEffect(() => {
        if (!isPending) {
            return;
        }

        if (previousJourneysRef.current === null) {
            previousJourneysRef.current = completedJourneys;
            return;
        }

        // Selector returns new reference only when data changes (memoized)
        const hasNewData = previousJourneysRef.current !== completedJourneys;

        if (!hasNewData) {
            return;
        }

        dispatch(setJourneyBadgePending(false));

        const previousJourneyIds = previousJourneysRef.current.map((j) => j.journeyId);
        const newJourneys = completedJourneys.filter((j) => !previousJourneyIds.includes(j.journeyId));

        // A badge journey (Legend) completes together with the journey that granted its last badge - it wins.
        const newJourney = newJourneys.find(hasCompletedBadgeActions) || newJourneys[0];

        if (newJourney?.journeyId) {
            dispatch(setJourneyBadgePopupState({isVisible: true, props: {journeyId: newJourney.journeyId}}));
        }

        previousJourneysRef.current = completedJourneys;
    }, [completedJourneys, isPending]);
};

export default useCheckBadgeEarn;
